// MUI Icons
import {
	CheckCircleOutline,
	FlashOnOutlined,
	LocalShippingOutlined,
	ShoppingCartCheckoutOutlined,
} from '@mui/icons-material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const FAQ_ITEMS = [
	{
		icon: ShoppingCartCheckoutOutlined,
		question: '¿Cómo gano cashback con Bumbei?',
		answer: (
			<>
				1. Inicia sesión en Bumbei
				<br />
				2. Haz clic en la tienda donde quieras comprar
				<br />
				3. Compra como siempre en esa tienda
				<br />
				<br />
				Nosotros rastreamos tu compra automáticamente y te damos cashback en
				bitcoin.
			</>
		),
	},
	{
		icon: LocalShippingOutlined,
		question: '¿Qué pasa después de comprar?',
		answer: (
			<>
				Las tiendas nos reportan tu compra en unos minutos.
				<br />
				Aparece como "pendiente" mientras validan que no hiciste devoluciones.
				<br />
				Entre 30 y 60 días después, si todo está bien, tu cashback pasa a estar
				disponible.
			</>
		),
	},
	{
		icon: FlashOnOutlined,
		question: '¿Cómo retiro mi cashback?',
		answer: (
			<>
				1. Crea una wallet compatible con Lightning Network (te recomendamos
				Muun o Blink Wallet)
				<br />
				2. Agrega tu dirección Lightning en tu perfil
				<br />
				3. ¡Haz tu retiro en segundos!
				<br />
				<br />
				No hay mínimos de retiro. Puedes sacar incluso centavos de peso.
			</>
		),
	},
	{
		icon: CheckCircleOutline,
		question: '¿La promoción aplica para todas las tiendas?',
		answer: (
			<>
				¡Sí! Todas las tiendas listadas en Bumbei aplican, salvo que indiquemos
				lo contrario en una promoción específica.
			</>
		),
	},
	{
		icon: HelpOutlineIcon,
		question: '¿Qué pasa si algo falla o no me aparece el cashback?',
		answer: (
			<>
				Puedes abrir una disputa desde tu cuenta con una captura de tu recibo y
				número de orden.
				<br />
				Nosotros nos encargamos de revisar con la tienda.
			</>
		),
	},
];
